import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";

import Card from "@components/ui-components/card";
import CompanyCard from "./company-card";
import DateRangePicker from "@components/fields/date-picker/range-picker";
import Filter from "../../common/filter";
import Flex from "@components/ui-components/flex";
import { FormProvider } from "react-hook-form";
import ImageWrapper from "@src/@core/components/ui-components/image-wrapper";
import { LAST_30_DAYS_DATE } from "@src/utility/constants";
import { LoaderOverlay } from "@components/spinner";
import LoadingButton from "@components/ui-components/loading-button";
import { NoDataComponent } from "@components/no-data-component";
import SideFilter from "@components/ui-components/side-filter";
import Upsert from "../companies/upsert";
import { getPlural } from "@src/utility/helpers/utils";
import size from "lodash/size";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import useFilter from "../../common/use-filter";
import { useRef } from "react";
import useStages from "./use-stages";
import { useTranslation } from "react-i18next";

export const Stages = () => {
    const {
        handleDragEnd,
        getAllStages,
        handleDeleteStage,
        setQueryParams,
        handleModal,
        modalConfig,
        loading,
        data: {
            pagination: { count },
            companyMap
        },
        updateLoading,
        stageList
    } = useStages();

    const containerRef = useRef();

    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getAllStages,
        defaultHandling: true,
        defaultValues  : LAST_30_DAYS_DATE
    });

    const {
        methods: filterMethods,
        onSubmit: filterSubmit,
        onReset: filterReset
    } = useFilter({
        setQueryParams
    });
    const { t } = useTranslation();

    const maintainence = false;
 
    return (
        <>
            {maintainence ? (
                <Flex align="center" justify="center" column>
                    <ImageWrapper
                        id="under-maintenance"
                        src="common/maintenance.png"
                        alt="Under-maintainence-banner"/>
                    <h2>{t("Stage board is currently under construction")}</h2>
                </Flex>
            ) : (
                <>
                    <LoaderOverlay
                        active={loading}
                        children={
                            <Card
                                containerClass="stage-container overflow-hidden"
                                bodyClass="d-flex flex-column h-100">
                                <div>
                                    <Flex justify="between" align="center" className="mb-1">
                                        <h2>
                                            {t(getPlural({ text: "Company", length: count, ies: true }))} (
                                            {count})
                                        </h2>
                                        <Flex justify="start" align="center">
                                            <DateRangePicker
                                                control={control}
                                                customOnChange={handleDateChange}
                                                maxDate={new Date()}
                                                id="date"
                                                name="date"/>
                                            <LoadingButton
                                                color="primary"
                                                icon="plus"
                                                text="Add Company"
                                                onClick={() => handleModal()}/>
                                            <SideFilter
                                                title="Filters"
                                                onSubmit={() => filterSubmit()}
                                                onReset={() => filterReset()}>
                                                <FormProvider {...filterMethods}>
                                                    <Filter />
                                                </FormProvider>
                                            </SideFilter>
                                        </Flex>
                                    </Flex>
                                    <DragDropContext
                                        onDragEnd={handleDragEnd}
                                        autoScrollerOptions={{
                                            startFromPercentage: 0.25
                                        }}>
                                        <LoaderOverlay active={updateLoading}>
                                            {/* Horizontal scroll area */}
                                            <div
                                                ref={containerRef}
                                                className="w-100 overflow-x-auto flex-grow-1 h-100">
                                                <Flex
                                                    className="h-100 content-width"
                                                    style={{
                                                        minWidth: "max-width"
                                                    }}>
                                                    {[...stageList].map(stage => {
                                                        const companies = companyMap[stage._id] || [];

                                                        return (
                                                            <Droppable key={stage._id} droppableId={stage._id}>
                                                                {(provided) => (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.droppableProps}
                                                                        className="border rounded bg-light d-flex flex-column flex-shrink-0 stage-column">
                                                                        <div className="position-sticky top-0 z-3 bg-white">
                                                                            <h4 className="w-100 bg-primary text-white p-2 text-center rounded">
                                                                                {stage.name}
                                                                            </h4>
                                                                        </div>

                                                                        <div className="flex-grow-1 overflow-y-auto" style={{ minHeight: 0 }}>
                                                                            {size(companies) ? (
                                                                                companies.map((company, index) => (
                                                                                    <Draggable
                                                                                        key={`${company._id}-${company.company_name}`}
                                                                                        draggableId={`${company._id}-${company.company_name}`}
                                                                                        index={index}>
                                                                                        {(provided) => (
                                                                                            <div
                                                                                                ref={provided.innerRef}
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}>
                                                                                                <CompanyCard
                                                                                                    handleDelete={handleDeleteStage}
                                                                                                    currentIndex={index}
                                                                                                    totalSize={size(companies)}
                                                                                                    handleEdit={handleModal}
                                                                                                    company={company}/>
                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                ))
                                                                            ) : (
                                                                                <NoDataComponent />
                                                                            )}
                                                                            {provided.placeholder}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        );
                                                    })}

                                                </Flex>
                                            </div>
                                        </LoaderOverlay>
                                    </DragDropContext>
                                </div>
                            </Card>
                        }/>
                    <Upsert
                        getCompanies={getAllStages}
                        handleModal={handleModal}
                        modalConfig={modalConfig}/>
                </>
            )}
        </>
    );
};
